rugHandler = {
    $rugSort        : $('.rug-sort'),
    $sfItem         : $('.sf-item'),
    $fsItem         : $('.fs-item'),
    $rugContent     : $('.rug-dynamic-content'),
    $triggShop      : $('.trigg-shop-panel'),
    $backShopPanel  : $('.close-shop-panel'),
    $shopFilter     : $('.panel-shop-filter'),
    $filterSelect   : $('.button-filter-select'),
    $sfContainer    : $('.shop-filter-container'),
    $sfResult       : $('.sf-selected-result'),
    shopHref        : $('.button-filter-select').attr('href'),
    $cellProduct    : $('.cell-product'),
    $single         : $('.single-collection'),
    $zoomImageContainer: $('.zoom-image-container'),
    isLoad          : false,
    currPage        : 1,
    setUrlTimeout   : null,

    setRugUrl: function($obj, returnUrl = false) {
        var self = this;

        var resultUrl = '';
        var filterData = {};
        $obj.each(function() {
            if ($(this).hasClass('is-selected')) {
                var filterType = $(this).data('filter-type');
                var filterId   = $(this).data('filter-id');
                if (!filterData[filterType]) filterData[filterType] = [];
                filterData[filterType].push(filterId);
            }
        });

        $.each( filterData, function( key, value ) {
            var tempUrl = key + '=' + value.join(',');

            resultUrl = resultUrl + ((resultUrl) ? '&' : '?') + tempUrl;
        });


        var sortData = self.$rugSort.find('.item-sort.is-selected').data('sort-name');

        if (sortData) resultUrl = resultUrl + ((resultUrl) ? '&' : '?') + 'psort='+sortData;

        if (returnUrl) {
            return resultUrl;
        } else {
            var path = window.location.pathname;
            var hash = window.location.hash;
            window.history.pushState("Set Rug Filter", "Set Rug Filter", path+hash+resultUrl);
        }
    },

    setRugSeries: function() {
        var self = this;

        if (self.$single.length > 0) {
            self.$single.each(function() {
                if ($(this).find('.series-head-container').length > 0) {
                    if (!mainHandler.$header.hasClass('has-series')) mainHandler.$header.addClass('has-series')
                    //if ($(this).find('header .series-head').length > 0 ) $(this).find('header .series-head').remove();
                    //$(this).find('.series-head').appendTo($(this).find('header'));
                    $(this).find('.series-head-container').remove();
                }
            });

            mainHandler.setGlobalStyle();
            //mainHandler.customMagellan();
        }
    },

    filterSelectedEl: function($objResult) {
        var self = this;
        var $frElCont = '';

        self.$fsItem.each(function() {
            if ($(this).hasClass('is-selected')) {
                var filterType = $(this).data('filter-type');
                var filterId   = $(this).data('filter-id');
                var filterLabel= $(this).text();

                if ($objResult) {
                    var $frEl = '<a href="javascript:void(0);" class="fr-item icon icon-times color-black" data-filter-id="'+filterId+'" data-filter-type="'+filterType+'">'+filterLabel+'</a>';

                    $frElCont = $frElCont + $frEl;
                }
            }
        });

        if ($frElCont) {
            $frElCont = '<div class="fr-item-container text-right">'+$frElCont+'</div>';
            $($frElCont).appendTo($objResult);
        }
    },

    filteringContent: function($obj, noScroll = false, init = false) {
        var self = this;

        if (!self.isLoad) {

            if (!noScroll) {
                $('html, body').animate({
                    scrollTop: ($obj.offset().top - $('header').outerHeight())
                }, 300);
            }

            var filterData  = {};
            var collIds     = [];
            var $objContent = $obj.find('.main-rug-content');
            var $objPaging  = $obj.find('.rug-paging');
            var $objResult  = $obj.find('.rug-filter-result');
            var $objSeries  = $obj.find('.series-head-cell');
            var $descCell   = $obj.find('.head-desc-cell');
            var collId      = $obj.data('collection-id');
            var perPage     = $obj.data('per-page');
            var isSingle    = $obj.data('is-single');

            if ($objResult) {
                $objResult.empty();
            }

            self.$fsItem.each(function() {
                if ($(this).hasClass('is-selected')) {
                    var filterType = $(this).data('filter-type');
                    var filterId   = $(this).data('filter-id');
                    var filterLabel= $(this).text();
                    
    
                    if (filterType == 'pa_collection') {
                        collIds.push(filterId);
                    } else {
                        if (!filterData[filterType]) filterData[filterType] = [];
                        if (filterId.includes(',')) {
                            var idArr = filterId.split(",");
                            idArr.forEach(function(item) {
                                filterData[filterType].push(item);
                            });
                        } else {
                            filterData[filterType].push(filterId);
                        }
                    }
                }
            });

            self.filterSelectedEl($objResult);

            var sortData = self.$rugSort.find('.item-sort.is-selected').data('sort-name');
            if (!sortData) sortData = '';

            $.ajax({
                type: 'POST',
                url: myAjax.ajax_url,
                data: {
                    action      : 'filter_product',
                    filters     : filterData,
                    sort        : sortData,
                    coll_id     : collId,
                    coll_ids    : collIds,
                    per_page    : perPage,
                    //curr_page   : self.currPage,
                    is_single   : isSingle,
                },
                
                beforeSend: function() {
                    self.isLoad = true;
                    $objContent.empty('');
                    $('html').addClass('loading');

                    if (self.currPage == 1) {
                        $objPaging.empty('');
                        $objSeries.empty('');
                        $descCell.empty('');
                    }
                },
    
                success: function(response) {
                    self.isLoad     = false;
                    var $resultHtml = response['html'];

                    /* console.log('start'+response['start']);
                    console.log('end'+response['end']); */

                    $objContent.replaceWith($($resultHtml).find('.main-rug-content'));

                    if (self.currPage == 1) {
                        $objPaging.replaceWith($($resultHtml).find('.rug-paging'));
                        $objSeries.replaceWith($($resultHtml).find('.series-head-cell'));
                        $descCell.replaceWith($($resultHtml).find('.head-desc-cell'));
                        $obj.find('.rug-head').attr('class', $($resultHtml).find('.rug-head').attr('class'));
                        $obj.find('.head-filter').attr('class', $($resultHtml).find('.head-filter').attr('class'));
                    }

                    $obj.find('.empty-rug').removeClass('hide');

                    $('html').removeClass('loading');

                    var hash = window.location.hash;
                    self.setRugUrl(self.$fsItem);

                    self.setRugSeries();

                    self.showingImage();

                    mainHandler.customMagellan();

                    /* if (!noScroll) {
                        $obj.find('.sticky').removeClass('is-at-bottom');
                        $obj.find('.sticky').addClass('is-at-top');
                        $obj.find('.sticky').css('top', '0px');
                    } */
                    
                    $(document).foundation();
                    Foundation.reInit($('[data-equalizer]'));
                    
                    if (init && hash) {
                        $(document).ready(function() {
                            setTimeout(mainHandler.smoothScroll('', hash, 'slow'), 500);
                        });
                    }
                }
            });
        }
    },

    setShopUrl: function() {
        var self = this;

        if (self.$sfContainer.find('.sf-item.is-selected').length > 0) {
            self.$sfContainer.addClass('is-selected');

            self.$sfResult.empty();

            var $selectedEl = '';
            self.$sfContainer.find('.sf-item.is-selected').each(function() {
                var filterId    = $(this).data('filter-id');
                var filterType  = $(this).data('filter-type');
                var filterLabel = $(this).find('.def-label').text();
                var $selEl      = '<a href="javascript:void(0);" class="rs-item icon icon-times color-hover" data-filter-id="'+filterId+'" data-filter-type="'+filterType+'">'+filterLabel+'</a>';

                $selectedEl = $selectedEl + $selEl;
            });

            $selectedEl = '<div class="sr-container">'+$selectedEl+'</div>';
            $($selectedEl).appendTo(self.$sfResult);
            
            var shopUrl = self.setRugUrl(self.$sfItem, true);
            shopUrl = self.shopHref + '/' + shopUrl;

            self.$filterSelect.attr('href', shopUrl);
        } else {
            self.$sfContainer.removeClass('is-selected');
            self.$sfResult.empty();

            self.$filterSelect.attr('href', self.shopHref);
        }
    },

    showingImage: function() {
        var self = this;

        //console.log($(document).find('img[data-src]'));
        
        $(document).find('img[data-src]').each(function() {
            var $img = $(this);
            var src = $img.attr("data-src");
      
            $img.attr("src", src).removeAttr("data-src").removeClass("hide");
        });
    
        $(window).resize();
    },

    init: function() {
        var self = this;

        self.$zoomImageContainer.zoom({
            magnify: 1.5,
        });

        self.$triggShop.on('click', function(e) {
            e.preventDefault();
            $('html').toggleClass('disable-scroll');
            $('header').toggleClass('nav-panel-show');
            self.$shopFilter.toggleClass('is-show');

            $(this).parent().find('.nav-item.current').toggleClass('hide-current');
            $(this).parent().find('.nav-item.trigg-shop-panel').toggleClass('force-current');
        });

        self.$backShopPanel.on('click', function(e) {
            e.preventDefault();
            self.$triggShop.click();
            mainHandler.$triggNav.click();
        })

        self.$sfItem.on('click', function(e) {
            e.preventDefault();
            $(this).toggleClass('is-selected');

            self.setShopUrl();
        });

        $(document).on('click', '.rs-item', function() {
            var filterId    = $(this).data('filter-id');
            var filterType  = $(this).data('filter-type');
            $(this).remove();
            self.$sfContainer.find('.sf-item[data-filter-id="'+filterId+'"][data-filter-type="'+filterType+'"]').click();
        });

        self.showingImage();
        $(window).on('load', function() {
            //self.showingImage();
        });

        self.$rugContent.each(function() {
            var $selfContent    = $(this);
            var $removeFilter   = $(this).find('.remove-filter');
            var $applyFilter    = $(this).find('.apply-filter');
            var $filterTrig     = $(this).find('.filter-trigg');
            var $itemSort       = $(this).find('.item-sort');
            var $itemFilter     = $(this).find('.item-filter');
            var $sortTrig       = $(this).find('.sort-trigg');
            var $rugFs          = $(this).find('.rug-fs-button');

            //self.filteringContent($selfContent, true, true);
            self.filterSelectedEl($selfContent.find('.rug-filter-result'));

            $(document).on('click', '.page-index', function(e) {
                if (!$(this).hasClass('is-current')) {
                    $selfContent.find('.page-index').removeClass('is-current');
                    $(this).addClass('is-current');

                    var $num = $(this).text();
    
                    self.currPage = $num;
    
                    //self.filteringContent($selfContent);
                    $selfContent.find('.rug-cell').addClass('hide');
                    $selfContent.find('.rug-cell').attr('aria-hidden', 'true');
                    $selfContent.find('.rug-cell[data-paging-num="'+$num+'"]').removeClass('hide');
                    $selfContent.find('.rug-cell[data-paging-num="'+$num+'"]').attr('aria-hidden', 'false');

                    $('html, body').animate({
                        scrollTop: ($selfContent.offset().top - $('header').outerHeight())
                    }, 500);

                    Foundation.reInit($('[data-equalizer]'));
                }
            });

            $(document).on('click', '.fr-item', function(e) {
                var $frItem     = $(e.target);
                var filterId    = $frItem.data('filter-id');
                var filterType  = $frItem.data('filter-type');
                $selfContent.find('.fs-item[data-filter-id="'+filterId+'"][data-filter-type="'+filterType+'"]').removeClass('is-selected');
                self.filteringContent($selfContent, true);
            });

            $filterTrig.on('click', function() {
                let top = $(window).scrollTop();
                
                if ($sortTrig.parent().hasClass('is-active')) $sortTrig.click();
                $rugFs.toggleClass('is-show');

                setTimeout(() => {
                    $(window).scrollTop(top);
                }, 400);
            });

            $sortTrig.on('click', function() {
                let top = $(window).scrollTop();

                if ($filterTrig.parent().hasClass('is-active')) $filterTrig.click();

                setTimeout(() => {
                    $(window).scrollTop(top);
                }, 400);
            });
    
            $itemFilter.on('click', function() {
                $(this).toggleClass('is-selected');
            });

            $itemSort.on('click', function() {
                self.currPage = 1;
                if (!$(this).hasClass('is-selected')) {
                    $selfContent.find('.item-sort').removeClass('is-selected');
                    $(this).addClass('is-selected');
                } else {
                    $(this).removeClass('is-selected');
                }
                
                $sortTrig.click();
                self.filteringContent($selfContent);
            });
    
            $applyFilter.on('click', function() {
                self.currPage = 1;
                self.filteringContent($selfContent, true);
            });
    
            $removeFilter.on('click', function() {
                self.currPage = 1;
                self.$fsItem.removeClass('is-selected');
                self.filteringContent($selfContent, true);
            });
        });
    }
}